export default {
  isLogged: (state) => {
    return Boolean(state.user);
  },
};

